import {LOADER, GET_CONFIGURATION_DATA, GET_TERM_STORE, CART_COMPARE_DATA, CART_OPEN} from '../../constants/reducerTypes';

const initialState = {isLoading: false};
// adding cart item to store from session storage
const cartItems = JSON.parse(window.sessionStorage.getItem('cartCompareData'));
const cartItemsSorted = (cartItems && cartItems.length) ?
  cartItems.sort((a, b) => (a.title > b.title ? 1 : -1)) : cartItems;
if (cartItems && Array.isArray(cartItems) && cartItems.length > 0) {
  initialState.cartItems = cartItemsSorted;
}
const generalReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER:
      return {
        ...state,
        isLoading: action.payload
      };
    case GET_CONFIGURATION_DATA:
      return {
        ...state,
        configuration: action.payload
      };
    case GET_TERM_STORE:
      return {
        ...state,
        termStore: action.payload
      };
    case CART_COMPARE_DATA:
      window.sessionStorage.removeItem('cartCompareData');
      window.sessionStorage.setItem('cartCompareData', JSON.stringify(action.payload));
      return {
        ...state,
        cartItems: (action.payload && action.payload.length) ?
          action.payload.sort((a, b) => (a.title > b.title ? 1 : -1)) : action.payload
      };
    case CART_OPEN:
      return {
        ...state,
        isCartOpen: action.payload
      };
    default:
      return state;
  }
};
export default generalReducer;
